import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useUserStore } from 'store';

function DismissConfirmDialog({ open, onClose }) {
  const { t } = useTranslation();
  const { user, fetchUser } = useUserStore();
  const [submitting, setSubmitting] = useState(false);

  const handleDismiss = async () => {
    if (!user?.id) return;

    setSubmitting(true);
    try {
      await axios.patch(`/api/users/${user.id}/`, {
        help_widget_dismissed: true,
      });
      await fetchUser();
      onClose();
    } catch (err) {
      console.error('Failed to dismiss help widget:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{t('Dismiss help widget?')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('You will no longer see the help widget. You can re-enable it from Settings in the Profile tab.')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          {t('Cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleDismiss}
          disabled={submitting}
        >
          {submitting ? <CircularProgress size={24} /> : t('Dismiss')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DismissConfirmDialog;
